import platform from 'platform'
import { compare } from 'compare-versions'
import { logError, VignetteNotSupportedError } from 'utils/datadog'

export const VIGNETTE_SUPPORTED_OR_DISABLED = 'supported_or_disabled'
export const VIGNETTE_UNSUPPORTED_IOS = 'unsupported_ios_version'
export const VIGNETTE_UNSUPPORTED_ANDROID = 'unsupported_android_version'

export function isVignetteSupported(useVignette, allowToRecord) {
  if (!useVignette || !allowToRecord) return VIGNETTE_SUPPORTED_OR_DISABLED

  const osFamily= platform.os.family
  const osVersion = platform.os.version

  if (osFamily === 'iOS' && compare(osVersion, '16', '<')) {
    logError(new VignetteNotSupportedError(osFamily, osVersion))
    return VIGNETTE_UNSUPPORTED_IOS
  }

  // special case covering iPadOS with desktop mode Safari
  if (isIPadOS() && platform.name === 'Safari' && compare(platform.version, '16', '<')) {
    logError(new VignetteNotSupportedError(osFamily, osVersion))
    return VIGNETTE_UNSUPPORTED_IOS
  }

  if (osFamily === 'Android' && compare(osVersion, '11', '<')) {
    logError(new VignetteNotSupportedError(osFamily, osVersion))
    return VIGNETTE_UNSUPPORTED_ANDROID
  }

  return VIGNETTE_SUPPORTED_OR_DISABLED
}

function isIPadOS() {
  return platform.os.family === 'OS X' && navigator.maxTouchPoints && navigator.maxTouchPoints > 2
}

